<template>
  <section>
    <AddInterests
      v-if="isEditingInterest"
      :selectedInterests="newInterests"
      :isProfile="false"
      :maxInterests="2"
    />
    <div
      class="createBox"
      id="largerCreateBox"
      :style="[privacyType != 'secret' ? { height: '535px' } : {}]"
      v-if="!isEditingInterest"
    >
      <p class="createBoxTitle">Create new group</p>
      <div class="titleBox">
        <input
          placeholder="Group Title"
          class="groupTitle"
          v-model="title"
          :maxlength="titleMax"
        />

        <div
          class="input-group-addon groupLength"
          v-text="titleMax - title.length"
        ></div>
      </div>

      <div class="createBoxColumns">
        <div class="groupTypeContainer">
          <div
            @click="selectType('secret')"
            class="groupType"
            :style="[
              privacyType == 'secret'
                ? { 'background-color': '#0fb9b1', color: 'white' }
                : {},
            ]"
          >
            <div class="imgSpace">
              <img
                v-if="privacyType == 'secret'"
                class="circleIcon"
                src="@/assets/createSecretSelected.png"
              />
              <img
                v-else
                class="circleIcon"
                src="@/assets/createSecretChat.png"
              />
            </div>
            <div class="createGroupColumn">
              <b>Secret</b>
            </div>
          </div>
          <div
            @click="selectType('private')"
            class="groupType"
            :style="[
              privacyType == 'private'
                ? { 'background-color': '#0fb9b1', color: 'white' }
                : {},
            ]"
          >
            <div class="imgSpace">
              <img
                v-if="privacyType == 'private'"
                class="circleIcon"
                src="@/assets/createPrivateSelected.png"
              />
              <img
                v-else
                class="circleIcon"
                src="@/assets/createPrivateChat.png"
              />
            </div>
            <div class="createGroupColumn">
              <b>Private</b>
            </div>
          </div>
          <div
            @click="selectType('public')"
            class="groupType"
            :style="[
              privacyType == 'public'
                ? { 'background-color': '#0fb9b1', color: 'white' }
                : {},
            ]"
          >
            <div class="imgSpace">
              <img
                v-if="privacyType == 'public'"
                class="circleIcon"
                src="@/assets/createPublicSelected.png"
              />
              <img
                v-else
                class="circleIcon"
                src="@/assets/createPublicChat.png"
              />
            </div>
            <div class="createGroupColumn">
              <b>Public</b>
            </div>
          </div>
        </div>
        <p class="typeText" v-if="privacyType == 'secret'">
          Must be invited to join (Not discoverable)
        </p>
        <p class="typeText" v-if="privacyType == 'private'">
          Must request to join (Discoverable)
        </p>
        <p class="typeText" v-if="privacyType == 'public'">
          Anyone can join (Discoverable)
        </p>
        <div class="flexColumn" v-if="privacyType != 'secret'">
          <b class="additionalInfoRow">More Options</b>
          <div class="globalRow">
            <p class="createBoxTitle">Make group global</p>
            <!--div
              class="circleCreate"
              :class="{ circleSelected: isGlobal }"
              @click="selectGlobal"
            ></div-->
            <div
              class="toggleBox globalToggle"
              @click="selectGlobal"
              :class="{ toggledBox: isGlobal }"
            >
              <div
                class="toggleCircle"
                :class="{ toggledCircle: isGlobal }"
              ></div>
            </div>
          </div>
          <p class="smallText">Students from other schools can join</p>
          <p class="createBoxTitle">Interests</p>
          <div class="flexRowNewGroup">
            <div
              class="iconRow"
              v-for="(interest, index) in newInterests"
              :key="index"
            >
              <Interest :icon="interest.unicode" :interest="interest.name" />
            </div>
            <div
              class="addInterestBox"
              @click="toggleInterest"
              v-if="newInterests.length == 0"
            >
              Add Interests
            </div>
            <div
              class="editInterestBox"
              @click="toggleInterest"
              v-if="newInterests.length > 0"
            >
              Edit Interests
            </div>
          </div>
          <p class="smallText">
            Add interests to have your group recommended to others
          </p>
          <p class="createBoxTitle">Description</p>
          <textarea
            v-model="description"
            placeholder="Add description"
            class="groupDescription"
            maxlength="130"
          />
        </div>
      </div>

      <button @click="createGroup" class="createButton">
        Create Group
        <p v-if="createFeedback.length > 0" class="feedBox">
          {{ createFeedback }}
        </p>
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import db from "@/db";
import AddInterests from "@/components/profile/AddInterests";
import Interest from "@/components/profile/Interest";

//import firebase from "@/firebase";
export default {
  components: {
    AddInterests,
    Interest,
  },

  data: () => ({
    title: "",
    createFeedback: "",
    description: "",
    users: [],
    searchString: "",
    searchArray: [],
    totalSearch: [],
    privacyType: "secret",
    isGlobal: false,
    //nameCharLeft: 30,
    titleMax: 30,
  }),

  mounted() {},

  watch: {
    searchString() {
      if (this.searchString.length != 0) {
        var lowerString = this.searchString.toLowerCase();
        this.searchArray = lowerString.split(/(?:-| )+/);
        this.searchDatabase();
      } else {
        this.totalSearch;
      }
    },
    /*titleLength() {
      this.nameCharLeft = 30 - this.title.length;
      console.log(this.nameCharLeft);
    },*/
  },

  computed: {
    ...mapState("messageBoard", ["searchingGroup"]),
    ...mapState("user", ["user"]),
    ...mapState("profile", ["isEditingInterest", "newInterests"]),
  },

  methods: {
    ...mapActions("messageBoard", ["setSearchGroup", "subscribeToTopic"]),
    ...mapActions("user", ["updateUserGroups"]),
    async searchDatabase() {
      var totalSearch = [];
      // Search Users
      if (!/\d/.test(this.searchString)) {
        await db
          .collection("users")
          .where("school_id", "==", this.user.school_id)
          .where("firstNameKeywords", "array-contains", this.searchArray[0])
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                id: doc.id,
                searchResult: doc.data().firstName + " " + doc.data().lastName,
                type: "users",
              };
              totalSearch.push(data);
            });
          });
        await db
          .collection("users")
          .where("school_id", "==", this.user.school_id)
          .where("lastNameKeywords", "array-contains-any", this.searchArray)
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              if (totalSearch.findIndex((x) => x.id == doc.id) == -1) {
                let data = {
                  doc: doc.data(),
                  searchResult: doc.data().lastName,
                  type: "users",
                };
                totalSearch.push(data);
              }
            });
          });
      }

      // Sort search based on relevency
      var sortedSearch = [];
      for (var option = 0; option < totalSearch.length; option++) {
        let relevency = this.commonChars(
          totalSearch[option].searchResult,
          this.searchString
        );
        totalSearch[option].relevency = relevency / this.searchString.length;
        if (relevency / this.searchString.length > 0.5) {
          sortedSearch.push(totalSearch[option]);
        }
      }
      sortedSearch.sort((a, b) => b.relevency - a.relevency);
      this.totalSearch = sortedSearch.slice(0, 5);
    },

    commonChars(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();
      s1 = s1.split(" ");
      s2 = s2.split(" ");
      let seenChars = [];
      let shortStr;
      let longStr;
      let counter = 0;

      if (s1.length < s2.length) {
        shortStr = s1;
        longStr = s2;
      } else {
        shortStr = s2;
        longStr = s1;
      }

      for (let i = 0; i < shortStr.length; i++) {
        var shortWord;
        var longWord;
        if (shortStr[i].length < longStr[i].length) {
          shortWord = shortStr[i];
          longWord = longStr[i];
        } else {
          shortWord = longStr[i];
          longWord = shortStr[i];
        }
        for (let j = 0; j < shortWord.length; j++) {
          if (
            longWord.indexOf(shortWord[j]) !== -1 &&
            !seenChars.includes(shortWord[j])
          ) {
            counter++;
            seenChars.push(shortWord[j]);
          }
        }
      }
      return counter;
    },
    addUser(userDoc) {
      this.users.push(userDoc);
      this.searchString = "";
    },
    removeUser(userDoc) {
      let index = this.users.indexOf(userDoc);
      this.users.splice(index, 1);
      this.searchString = "";
    },
    toggleInterest() {
      this.$store.commit("profile/setIsEditingInterest", true);
    },
    selectType(privacyType) {
      this.privacyType = privacyType;
      if (privacyType == "secret") {
        document.getElementById("largerCreateBox").style.height = "250px";
      } else if (privacyType == "public" || privacyType == "private") {
        document.getElementById("largerCreateBox").style.height = "535px";
      }
    },
    selectGlobal() {
      this.isGlobal = !this.isGlobal;
    },
    createGroup() {
      if (this.title.length == 0) {
        this.createFeedback = "Please enter a group title";
      } else if (this.title.length > 30) {
        this.createFeedback = "Title cannot be longer than 30 characters";
      } else {
        let randomNum = Math.floor(Math.random() * 8);
        let arrayImgs = [
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupPink.png?alt=media&token=1b51adb4-7379-41ba-a118-6bfbd5ae1630",
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupRed.png?alt=media&token=5d2fcb19-519f-4266-96fd-a71794d94e8b",
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupBlue.png?alt=media&token=59e33923-ac24-477b-8e46-7cd235333df5",
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupOrange.png?alt=media&token=16676fe7-8a18-43c6-9129-0d96fa1be423",
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupGreen.png?alt=media&token=bb717f63-38c0-4c66-a625-5c0a146f66de",
          "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupCyan.png?alt=media&token=a80395f4-83eb-458d-a719-2ba26333845c",
        ];
        this.createFeedback = "";
        let keywords = this.addKeyWords(this.title);
        let data = {
          name: this.user.firstName + " " + this.user.lastName,
          profileImage: this.user.profileImage,
          user_id: this.user.id,
        };
        const postId = "p" + db.collection("posts").doc().id;
        const groupId = db.collection("groups").doc().id;
        let post = {
          content:
            this.user.firstName +
            " " +
            this.user.lastName +
            " joined the group",
          created_at: Date.now(),
          id: postId,
          profileImage: this.user.profileImage,
        };
        db.collection("posts")
          .doc(postId)
          .set(post);
        var group;
        if (this.privacyType == "secret") {
          group = {
            admin: [this.user.id],
            name: this.title,
            hasSeenLastPost: [data],
            users: [data],
            userCount: 1,
            recentPosts: [post],
            privacyType: this.privacyType,
            school_id: this.user.school_id,
            keywords: keywords,
            profileImage: arrayImgs[randomNum],
          };
        } else {
          group = {
            admin: [this.user.id],
            name: this.title,
            hasSeenLastPost: [data],
            users: [data],
            userCount: 1,
            interests: this.newInterests,
            recentPosts: [post],
            privacyType: this.privacyType,
            school_id: this.user.school_id,
            keywords: keywords,
            description: this.description,
            profileImage: arrayImgs[randomNum],
          };
        }
        this.isGlobal ? (group.isGlobal = true) : "";
        db.collection("groups")
          .doc(groupId)
          .set(group);
        group.id = groupId;
        group.type = "groups";
        (group.lastVisited = Date.now()), (group.notificationsEnabled = true);
        this.user.groups.push(group);
        this.$store.commit("messageBoard/setGroupId", group.id);
        this.$store.commit("messageBoard/setGroupName", group.name);
        this.$store.commit("messageBoard/setGroupType", group.type);
        this.$store.commit("messageBoard/setCurGroup", group);
        this.$store.commit("profile/setInterests", []);
        this.$store.commit("user/setUser", this.user);
        this.updateUserGroups();
        this.$router.push({
          name: "MessageBoard",
          params: {
            name: group.name,
            id: group.id,
            type: group.type,
          },
        });
        this.$store.commit("messageBoard/setCreateGroup", false);
        this.$store.commit("groupInfo/setAddingMembers", true);
        this.subscribeToTopic({ groupId: groupId, user: this.user });
      }
    },
    addKeyWords(name) {
      var letters = [];
      var some_letters = [];
      var groupName = name.split(" ");
      for (var i = 0; i < groupName.length; i++) {
        var word = groupName[i];
        for (var l = 1; l < word.length + 1; l++) {
          some_letters.push(word.substring(0, l).toLowerCase());
        }
      }
      for (var k = 1; k < name.length + 1; k++) {
        letters.push(name.substring(0, k).toLowerCase());
      }
      letters = some_letters.concat(letters);
      letters = letters.filter((v, i, a) => a.indexOf(v) === i);
      return letters;
    },
  },
};
</script>

<style scoped>
.createBox {
  background-color: white;
  width: 700px;
  height: 250px;
  padding: 20px;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  border-radius: 20px;
  transition: height 0.1s ease-in-out;
}
.fullHeight {
  height: 1000px !important;
}
.createBoxColumns {
  display: flex;
  flex-direction: column;
  width: 630px;
}
.createBoxTitle {
  font-size: 20px;
  font-weight: bold;
}
.closeUser {
  height: 20px;
  width: 20px;
  border: none;
  border-radius: 50%;
  background-color: #e0e0e0;
  cursor: pointer;
  z-index: 0;
  margin-left: 5px;
}
.closeUser:hover {
  background-color: #cacaca;
}
.titleBox {
  width: 630px;
  display: flex;
  flex-direction: row;
  height: 50px;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #b8b8b8;
  margin-bottom: 10px;
}
.groupTitle {
  font-size: 25px;
  width: 600px;
  border: none;
  outline: none;
  font-weight: thin !important;
}
.groupLength {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 20px;
  border-radius: 5px 5px 0 0;
}
.groupDescription {
  margin: 5px 0 10px 0;
  font-size: 18px;
  padding: 5px;
  width: 100%;
  height: 50px;
  display: flex;
  flex: 1 1 auto;
  border: none;
  outline: none;
  font-weight: thin !important;
  border: thin #e0e0e0 solid;
  border-radius: 5px;
  padding-bottom: 10px;
  resize: none;
}
.userContainer {
  display: inline-block;
  font-size: 18px;
}
.inputName {
  padding: 7px;
  margin: 2px;
  font-size: 15px;
  color: white;
  background-image: linear-gradient(to right, #0988e3, #38ada9);
  border-radius: 5px;
  display: flex;
  align-items: center;
}
.searchUser {
  font-size: 19px;
  width: 200px;
  margin-bottom: 5px;
  border: none;
  outline: none;
  border-bottom: 1px solid black;
}
.userDropDown {
  width: 200px;
  border-radius: 10px;
  position: fixed;
  margin-top: 30px;
  padding: 5px 10px 5px 5px;
  background-color: white;
  max-height: 50vh;
  overflow-y: hidden;
  box-shadow: 1px 1px 6px #e0e0e0;
  z-index: 1;
}
.userDropDown:hover {
  overflow-y: overlay;
}
.groupTypeContainer {
  width: 400px;
  display: flex;
  flex-direction: row;
  z-index: 5;
}
.groupType {
  width: 100%;
  min-height: 42px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0px 5px 7px 0;
  padding: 0 25px 0 0;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: thin solid #e0e0e0;
  background-color: white;
}
.groupType:hover {
  background-color: #f0f0f0;
}
.groupTypeTitle {
  font-size: 20px;
}
.groupTypeSubtitle {
  font-size: 15px;
}
.groupImage {
  width: 80px;
  height: 80px;
  border-radius: 10px;
}
.createButton {
  width: 630px;
  height: 40px;
  min-height: 39px;
  color: rgb(9, 132, 227);
  font-weight: 600;
  font-size: 18px;
  border-radius: 10px;
  cursor: pointer;
  border: none;
  background-color: #0fb9b150;
}
.createButton:hover {
  background-color: #0fb9b190;
}
.createButton:active {
  transform: scale(0.97);
}
.additionalInfoRow {
  width: 100%;
  height: 30px;
  background: #e0e0e0;
  color: #838383;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #d0d0d0;
  border-radius: 5px;
}
.globalRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}
.globalTitle {
  font-weight: bold;
}
.circleCreate {
  height: 26px;
  width: 26px;
  margin: 5px 10px 5px 20px;
  border: thin #0fb9b1 solid;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.circleCreate:hover {
  border: 3px #0fb9b1 solid;
}
.circleSelected {
  border: 13px #0fb9b1 solid;
}
.circleSelected:hover {
  border: 13px #0fb9b1 solid;
}
.globalToggle {
  margin-left: 15px;
}
.toggleBox {
  width: 45px;
  height: 26px;
  background: #e0e0e0;
  border-radius: 30px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  transition: 0.2s ease-in-out;
}
.toggledBox {
  background: #0fb9b1;
  /*justify-content: flex-end;*/
}
.toggleCircle {
  height: 21px;
  width: 21px;
  background: white;
  border-radius: 50%;
  margin: 0 3px;
  transition: 0.2s ease-in-out;
}
.toggledCircle {
  margin: 0 3px 0 21px;
}
.smallText {
  font-size: 12px;
  color: #838383;
  border-bottom: #e0e0e0 thin solid;
  margin-bottom: 10px;
}
.createGroupColumn {
  display: flex;
  flex-direction: column;
}
.typeText {
  margin-bottom: 17px;
  height: 14px;
  font-weight: 600;
  color: #838383;
}
.circleIcon {
  height: 30px;
  margin: 5px;
}
.imgSpace {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 70px;
}
.flexRowNewGroup {
  display: flex;
  flex-direction: row;
}
.addInterestBox {
  border: thin #e0e0e0 solid;
  padding: 3px 7px 3px 7px;
  border-radius: 5px;
  text-align: center;
  width: 100%;
}
.addInterestBox:hover {
  background: #f0f0f0;
  cursor: pointer;
}
.editInterestBox {
  border: thin #e0e0e0 solid;
  border-radius: 5px;
  text-align: center;
  width: 150px;
  height: 30px;
  margin: 2px 0 0 5px;
  padding-top: 2px;
}
.editInterestBox:hover {
  background: #f0f0f0;
  cursor: pointer;
}
.iconRow {
  width: fit-content !important;
}
.feedBox {
  position: absolute;
  background: #00000085;
  padding: 5px 15px;
  border-radius: 10px;
  color: white;
  transform: translate(70%, 50%);
}
</style>
